document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const drawer = document.querySelector('[data-mobile-menu]');
      if (!drawer) return;
      const open = drawer.toggleAttribute('data-open');
      button.setAttribute('aria-expanded', String(open));
      button.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
  });

  const menu = document.querySelector('[data-mobile-menu]');
  const menuButton = document.querySelector('[data-menu-toggle]');
  const closeMenu = () => { if (!menu || !menuButton) return; menu.removeAttribute('data-open'); menuButton.setAttribute('aria-expanded', 'false'); menuButton.setAttribute('aria-label', 'Open menu'); };
  menu?.addEventListener('click', event => { if (event.target.closest('a')) closeMenu(); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && menu?.hasAttribute('data-open')) { closeMenu(); menuButton.focus(); } });
  document.addEventListener('click', event => { if (menu?.hasAttribute('data-open') && !event.target.closest('.site-header')) closeMenu(); });

  document.querySelectorAll('[data-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-slider-track]');
    slider.querySelector('[data-prev]')?.addEventListener('click', () => track.scrollBy({left: -track.clientWidth * .8, behavior: 'smooth'}));
    slider.querySelector('[data-next]')?.addEventListener('click', () => track.scrollBy({left: track.clientWidth * .8, behavior: 'smooth'}));
  });
});
document.addEventListener('change', event => { if (!event.target.matches('[data-collection-sort]')) return; const url = new URL(location.href); url.searchParams.set('sort_by', event.target.value); url.searchParams.delete('page'); location.assign(url.href); });
